/**
 * 公共方法，业务无关
 */

import Cookies from 'js-cookie'
import clientEnv from './clientEnv'
import app from './app'
import { isPhone } from './reg'
// import router from '@/router'
import API from 'api'
import vivoPay from '@vivo/pay-jssdk'
import { remoteLoad } from './dom'

// 格式化距离
function formatDistance(value) {
  if (value < 1000) {
    return value + 'm'
  } else {
    return (value / 1000).toFixed(1) + 'km'
  }
}

function setCookie(name, value, expires) {
  var rootDomainList = {
    'com.cn': 1,
    'js.cn': 1,
    'net.cn': 1,
    'gov.cn': 1,
    'com.hk': 1,
    'co.nz': 1
  }
  var host = window.location.hostname
  var domain = host.split('.')

  // 如果当前域名是顶级域名或二级域名，直接使用
  // 如果当前域名超过两级，检查二级域名是否存在配置列表中，如果存在，则使用到三级域名
  // 如果不存在，则使用到二级域名
  if (domain.length > 2) {
    domain = rootDomainList[domain.slice(-2).join('.')] ? domain.slice(-3) : domain.slice(-2)
  }
  domain = domain.join('.')

  // 设置 cookie
  Cookies.set(encodeURIComponent(name), value, { path: '/', domain: domain, expires: expires })
}

// 获取本地数据
function getCookie(name) {
  return Cookies.get(encodeURIComponent(name)) || ''
}

// 移除本地数据
function removeCookie(name) {
  return Cookies.remove(encodeURIComponent(name)) || ''
}

function getVisitType() {
  if (clientEnv.isWx) {
    return 'weichat'
  } else if (clientEnv.isAlipay) {
    return 'alipay'
  } else if (clientEnv.isVivoApp) {
    return 'vivoapp'
  } else if (clientEnv.isVHome) {
    return 'vhomeapp'
  } else if (clientEnv.isBankabc) {
    return 'bankABC'
  } else if (clientEnv.isAndroid || clientEnv.isIOS) {
    return 'wap'
  } else {
    return 'pc'
  }
}

// 序列化
function serial(params) {
  var arr = []
  for (var p in params) {
    var value = encodeURIComponent(params[p])
    try {
      if (clientEnv.isBankabc) {
        value = encodeURIComponent(value)
      }
    } catch (e) {
      console.log(e)
    }
    arr.push(p + '=' + value)
  }
  return arr.join('&')
}

// 对象的value进行编码
function encodeJSON(params) {
  var obj = {}
  for (var p in params) {
    var value = encodeURIComponent(params[p])
    try {
      if (clientEnv.isBankabc) {
        value = encodeURIComponent(value)
      }
    } catch (e) {
      console.log(e)
    }
    obj[p] = value
  }
  return obj
}

// 反序列化
function parseQueryString(qs) {
  qs = qs.split('+').join(' ')

  var params = {}
  var re = /[?&]?([^=]+)=([^&]*)/g
  var tokens = re.exec(qs)

  while (tokens) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
    tokens = re.exec(qs)
  }

  return params
}

// 获取参数中指定name的值
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var paramStr = window.location.search ? window.location.search.substr(1) : ''
  paramStr += '&' + (window.location.hash.split('?')[1] || '')
  var r = paramStr.match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}

// 从url中获取参数
function getParameter(key, url) {
  var b = url || window.location.search
  var c = new RegExp('[?&]' + key + '=([^&]+)', 'g')
  var d = c.exec(b)
  return d != null && decodeURIComponent(d[1])
}

function getQueryParams(qs) {
  qs = qs.split('+').join(' ')
  let params = {}
  let tokens
  let re = /[?&]?([^=]+)=([^&]*)/g
  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2])
  }
  return params
}

function formatMoney(value) {
  var num = parseFloat(value)
  if (isNaN(num)) {
    return value
  }
  return num.toFixed(2)
}

function formatNumber(value) {
  value = isNaN(Number(value)) ? value : Number(value)
  if (typeof value === 'number') {
    return (value * 100) % 100 === 0 ? value : parseFloat(value.toFixed(2))
  } else {
    return value
  }
}
function formatMoneyInteger(value) {
  return formatMoney(value).split('.')[0]
}

function formatMoneyDecimal(value) {
  return '.' + formatMoney(value).split('.')[1]
}
// 总数格式化
function formatCount(value) {
  let fValue = value
  if (typeof value === 'number') {
    if (value >= 10 && value < 1000) {
      fValue = parseInt(value / 10, 10) * 10 + '+'
    }
    if (value >= 1000 && value < 10000) {
      fValue = parseInt(value / 100, 10) * 100 + '+'
    }
    if (value >= 10000) {
      if (value % 10000 == 0) {
        fValue = value / 10000 + '万'
      } else {
        let sValue = (value / 10000).toString()
        let dotIndex = sValue.indexOf('.')
        if (sValue.substring(dotIndex + 1, dotIndex + 2) == 0) {
          fValue = sValue.substring(0, sValue.lastIndexOf('.')) + '万+'
        } else {
          fValue = sValue.substring(0, sValue.lastIndexOf('.') + 2) + '万+'
        }
      }
    }
  }
  if (!fValue) {
    fValue = ''
  }
  return fValue
}

function formatTime(value, type = 1) {
  let dateObj, month, date, hours, minutes, seconds
  if (!value) {
    return ''
  }
  dateObj = new Date(value)
  month = dateObj.getMonth() + 1
  date = dateObj.getDate()
  hours = dateObj.getHours()
  minutes = dateObj.getMinutes()
  seconds = dateObj.getSeconds()
  if (type) {
    return (
      (month < 10 ? '0' : '') +
      month +
      '月' +
      (date < 10 ? '0' : '') +
      date +
      '日' +
      (hours < 10 ? '0' : '') +
      hours +
      ':' +
      (minutes < 10 ? '0' : '') +
      minutes +
      ':' +
      (seconds < 10 ? '0' : '') +
      seconds
    )
  } else {
    return (
      month +
      '月' +
      date +
      '日' +
      (hours < 10 ? '0' : '') +
      hours +
      ':' +
      (minutes < 10 ? '0' : '') +
      minutes +
      ':' +
      (seconds < 10 ? '0' : '') +
      seconds
    )
  }
}

function updateURLParameter(url, arg, arg_val) {
  var pattern = arg + '=([^&]*)'
  var replaceText = arg + '=' + arg_val
  if (url.match(pattern)) {
    var tmp = '/(' + arg + '=)([^&]*)/gi'
    tmp = url.replace(eval(tmp), replaceText)
    return tmp
  } else {
    if (url.match('[?]')) {
      return url + '&' + replaceText
    } else {
      return url + '?' + replaceText
    }
  }
}

function jumpToMiniUrl(url, len, failFn){
  if(!window?.wx?.miniProgram) return
  // 如果页面栈达到10层，就使用重定向跳转
  if (len > 7) {
    window.wx.miniProgram.redirectTo({ url, fail: ()=>{
      failFn && failFn()
    }})
  } else {
    window.wx.miniProgram.navigateTo({ url, fail: ()=>{
      failFn && failFn()
    }})
  }
}

function formatDate(time, detail, type = 0) {
  let dateObj
  if (('' + time).toString().indexOf('-') > -1) {
    dateObj = new Date(time.toString().replace(/\-/g, '/'))
  } else {
    dateObj = new Date(Number(time))
  }
  let yearTxt = dateObj.getFullYear()
  let monthTxt = dateObj.getMonth() + 1
  let dateTxt = dateObj.getDate()
  let hourTxt = dateObj.getHours()
  let minuTxt = dateObj.getMinutes()
  let secoTxt = dateObj.getSeconds()

  monthTxt < 10 && (monthTxt = '0' + monthTxt)
  dateTxt < 10 && (dateTxt = '0' + dateTxt)
  hourTxt < 10 && (hourTxt = '0' + hourTxt)
  minuTxt < 10 && (minuTxt = '0' + minuTxt)
  secoTxt < 10 && (secoTxt = '0' + secoTxt)

  if (type === 1)
    return yearTxt + '.' + monthTxt + '.' + dateTxt + (detail ? ' ' + hourTxt + ':' + minuTxt + ':' + secoTxt : '')
  else return yearTxt + '-' + monthTxt + '-' + dateTxt + (detail ? ' ' + hourTxt + ':' + minuTxt + ':' + secoTxt : '')
}

/**
 * @param {String} value -- 2017-07-22 00:00:00 这种格式的字符串
 * @return {Number} timeStamp -- 时间戳
 */
function formatTimeStr(value) {
  if (!value || typeof value !== 'string') {
    return ''
  }
  let time = value.replace(/-/g, '/')
  let timeStamp = new Date(time).getTime()
  return timeStamp
}

function formatPhone(phone) {
  return phone && phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

// 函数节流
let timer

function debounce(func, delay = 500) {
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

/**
 * @description 加密手机号，中间四位数用*代替
 * @date 2019-04-04
 * @param {*} phoneNumber
 * @returns string
 */
function encryptMobile(mobile) {
  if (!isPhone(mobile)) {
    return ''
  }

  return String(mobile).replace(/^(\d{3})(\d{4})(\d{4})$/, '$1****$3')
}

/**
 * @description 评论昵称格式化
 * @param {*} value
 * @returns string
 */
function formatName(value) {
  if (!value || value.length < 2) {
    return value
  } else {
    return value.replace(/^(.)(.*)(.)$/g, '$1***$3')
  }
}

function jumpToShop(url, isReplace) {
  let newUrl = 'https://shop.vivo.com.cn/wap' + url
  // let newUrl = 'http://mvivoshop.vivo.com.cn:3000/wap' + url
  if (isReplace) {
    location.replace(newUrl)
  } else {
    location.href = newUrl
  }
}

// 选购新品, 加上index.html是为了让app拦截，跳转到app的选购页面
function goBuy(isReplace) {
  jumpToShop('/index.html', isReplace)
}

/**
 * @description 返回上一页，如果无历史，则返回商城首页
 * @param 无
 * @returns string
 */
function goBack() {
  if (clientEnv.isVivoApp) {
    app.appGoBack()
  } else {
    try {
      if (window.history.length > 1 || (document.referrer && document.referrer != location.href)) {
        history.go(-1)
      } else {
        jumpToShop('/index.html')
      }
    } catch (e) {}
  }
}

/**
 * @description 跳转到首页
 * @param 无
 * @returns string
 */
function jumpToHome() {
  if (clientEnv.isVivoApp) {
    app.skipToHomePage()
  } else {
    location.href = 'https://shop.vivo.com.cn/wap/index.html'
  }
}
/**
 * @description 跳转到选购页
 * @param 无
 * @returns string
 */
function jumpToNav() {
  if (clientEnv.isVivoApp) {
    if (clientEnv.isIOSVivoApp) {
      location.href = 'space://vivo.com/main?targetPackage=com.vivo.space&id=1&nativeType=31'
    } else {
      app.openAppByDeepLink({
        deepLink: 'space://vivo.com/main?targetPackage=com.vivo.space&id=1&nativeType=31'
      })
    }
  } else {
    location.href = 'https://shop.vivo.com.cn/wap/product/phone'
  }
}

/**
 * @description 跳转到个人中心

 * @param 无
 * @returns string
 */
function jumpToMy() {
  if (clientEnv.isVivoApp && !clientEnv.isIOSVivoApp) {
    if (clientEnv.isVivoPad && clientEnv.appVersion < 6390) {
      app.openAppByDeepLink({
        deepLink: 'space://vivo.com/main?targetPackage=com.vivo.space&id=3&nativeType=31'
      })
    } else {
      app.openAppByDeepLink({
        deepLink: 'space://vivo.com/main?targetPackage=com.vivo.space&id=4&nativeType=31'
      })
    }
  } else {
    location.href = 'https://shop.vivo.com.cn/wap/my'
  }
}
/**
 * @description 跳转到在线客服
 * @param 无
 * @returns string
 */
function jumpToKeFu() {
  window.location.href =
    'https://kefu.vivo.com.cn/robot-vivo/mobileChat.html?f=mall&forVivoSpace=share.mp.qq.com/cgi/share.php'
}

function jumpToActivity() {
  location.href = 'https://mshopact.vivo.com.cn/page/ms'
}

/**
 * @description 富文本中的图片进行懒加载
 * @param {string} htmlStr
 * @returns string
 */
function convertHTML(htmlStr) {
  return htmlStr && htmlStr.replace(/src/g, 'data-src')
}

/**
 * 格式化富文本数据，将src替换为data-src，且加上webp__disabled类名，禁止富文本使用webp图片
 */
function formatRichTextLazyHTML(str) {
  return str.replace(/<img([^>]+)src(=[^>]+)>/g, '<img class="webp__disabled"$1data-src$2>')
}

function dealPayData(res, type, cb, tempTerminal = -1) {
  // 一站式换新新增toastMsg
  if (res?.toastMsg) {
    app.toast(res.toastMsg)
  }
  /**
   * jumpType=1: native收银台 2:老版H5收银台 3:新版H5收银台 4:跳转内部链接
   */
  let paraMap = res.payData
  let jumpType = res.jumpType
  res.tempTerminal = tempTerminal
  res.type = type // 结算来源
  // native收银台
  if (jumpType == 1 && res.payNativeData) {
    app.vivopayByNative({
      data: res,
      success(isSuc) {
        cb && cb(isSuc)
      },
      error() {
        gotoWebpay({ url: res.orderPayUrl, data: paraMap, type, cb })
      }
    })
    return
  }
  // 老版H5收银台
  if (jumpType == 2) {
    gotoWebpay({ url: res.orderPayUrl, data: paraMap, type, cb })
    return
  }
  // 新版H5收银台
  if (jumpType == 3) {
    let locationReplace = type == 'settle' || type == 'afresh' ? '1' : ''
    res.payH5Data.locationReplace = locationReplace
    vivoPay.requestPayment(res.payH5Data, err => {
      if (err) {
        gotoWebpay({ url: res.orderPayUrl, data: paraMap, type, cb })
        console.error(err.message)
      } else {
        cb && cb()
        console.log('成功发起支付')
      }
    })
    setupGrayTestData(res.grayTestData, type)
    return
  }
  // 内部链接及其它
  if (res._isFromRecycleConfirm == 1) {
    cb && cb()
    window.location.replace(res.orderPayUrl)
  } else {
    window.location = res.orderPayUrl
  }
}
function gotoWebpay({ url, data, type, cb }) {
  // 内部跳转(jumpType=4)，待废弃
  if (url.indexOf('http') === -1) {
    let newUrl = url.replace('/wap', '')
    window.router.push({
      path: newUrl,
      query: data
    })
    return
  }
  // 外部跳转
  // 埋点
  setupGrayTestData(data.grayTestData, type)
  cb && cb(true)
  // 创建一个 form
  var form1 = document.createElement('form')
  form1.id = 'form1'
  form1.name = 'form1'
  // 添加到 body 中
  document.body.appendChild(form1)
  // 创建一个输入
  for (let it in data) {
    var input = document.createElement('input')
    // 设置相应参数
    input.type = 'text'
    input.name = it
    input.value = data[it]
    // 将该输入框插入到 form 中
    form1.appendChild(input)
  }
  // form 的提交方式
  form1.method = 'POST'
  // form 提交路径
  form1.action = url
  // 对该 form 执行提交
  form1.submit()
  // 删除该 form
  document.body.removeChild(form1)
}
/**
 * @description 收银台埋点打点
 * @param {Object} grayTestData
 * @param {String} type
 */
function setupGrayTestData(grayTestData, type) {
  if (grayTestData) {
    setCookie('grayPlanId', grayTestData.plan_id)
    setCookie('grayTestId', grayTestData.test_id)
    setCookie('orderId', grayTestData.order_id)
  } else {
    removeCookie('grayPlanId')
    removeCookie('grayTestId')
    removeCookie('orderId')
  }
  setCookie('pageSource', type)
}

/**
 * @description 弹层后阻止背景滚动
 * @param {Boolean} isStop
 */
let g_win_scrollTop = {}

function stopWinScroll(isStop) {
  let htmlDom = document.documentElement
  let height = window.screen.availHeight
  let bdEl = document.body
  if (isStop) {
    g_win_scrollTop.scrollTop = window.scrollY
    bdEl.style.marginTop = -g_win_scrollTop.scrollTop + 'px'
    bdEl.style.overflow = 'hidden'
    bdEl.style.height = height + 'px'
    htmlDom.style.overflow = 'hidden'
    setTimeout(function () {
      bdEl.style.height = ''
    }, 40)
  } else {
    bdEl.style.marginTop = ''
    bdEl.style.overflow = ''
    htmlDom.style.overflow = ''
    setTimeout(function () {
      window.scrollTo(0, g_win_scrollTop.scrollTop)
    }, 0)
  }
}

/**
 * 适配微信大字体
 *
 */
function handleWXFontSize() {
  if (typeof WeixinJSBridge == 'object' && typeof window.WeixinJSBridge.invoke == 'function') {
    handleFontSize()
  } else {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handleFontSize)
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    window.WeixinJSBridge.invoke('setFontSizeCallback', {
      fontSize: 0
    })
    // 重写设置网页字体大小的事件
    window.WeixinJSBridge.on('menu:setfont', function () {
      window.WeixinJSBridge.invoke('setFontSizeCallback', {
        fontSize: 0
      })
    })
  }
}

async function isLogin() {
  try {
    const res = await API.initAuthInfo()
    if (res.vivo_account_cookie_iqoo_openid) {
      return true
    }
  } catch (e) {}
  return false
}

// 获取手机的机型
function getBuild() {
  const arr = clientEnv.ua.split(';')
  const str = arr.find(element => element.includes('build'))
  try {
    return str.split('build')[0].trim()
  } catch (error) {
    return ''
  }
}

/**
 * 获取分享、收藏、加入购物车赠送的积分
 */
function shareRewardTip(type, data) {
  let tip = ''
  if (data && (data.pointsReward || data.experiencesReward)) {
    if (data.pointsReward) {
      tip += data.pointsReward + '积分'
    }
    if (data.experiencesReward) {
      if (data.pointsReward) {
        tip += '+'
      }
      tip += data.experiencesReward + '经验值'
    }
    tip =
      type +
      '成功，+' +
      tip +
      '<span class="drop-gold-effect"><i></i><i></i><i></i><i></i><i></i><i></i><em class="box"></em></span>'
  }
  return tip ? `<span style="display: flex;align-items: center;white-space: nowrap;">${tip}</span>` : ''
}

/**
 * 判断是否是深色
 * @param {颜色数组} colors
 * @param {临界值} darkPonit
 */
function isDarkColor(colors, darkPonit = 192) {
  let colorArr = Array.isArray(colors) ? colors : [colors]

  let rTotal = 0
  let gTotal = 0
  let bTotal = 0
  for (let color of colorArr) {
    rTotal += colorRgb(color)[0]
    gTotal += colorRgb(color)[1]
    bTotal += colorRgb(color)[2]
  }
  return (rTotal * 0.299 + gTotal * 0.587 + bTotal * 0.114) / colorArr.length <= darkPonit
}

/**
 * 颜色转rgb
 * @param {Hex} sColor hex 颜色
 */
function colorRgb(sColor) {
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  sColor = sColor.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // 处理六位的颜色值
    var sColorChange = []
    for (var j = 1; j < 7; j += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(j, j + 2)))
    }
    return sColorChange
  } else {
    return sColor
  }
}

/*
 * @param x {Object} 对象1
 * @param y {Object} 对象2
 * @return  {Boolean} true 为相等，false 为不等
 */
function deepEqual(x, y) {
  // 指向同一内存时
  if (x === y) {
    return true
  } else if (typeof x == 'object' && x != null && typeof y == 'object' && y != null) {
    if (Object.keys(x).length != Object.keys(y).length) return false

    for (var prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) return false
      } else return false
    }

    return true
  } else return false
}
// TODO:Toast需要处理该类场景
function toggleClickable(clickable) {
  const action = clickable ? 'add' : 'remove'
  document.body.classList[action]('pointer--unclickable')
}

function isShowHeader() {
  return !clientEnv.isWx && !clientEnv.isQQ && !clientEnv.isAlipay && !clientEnv.isVHome
}

// 校验输入内容是否是中英文、数字、中英文标点符号、空格
function inputCheck(str) {
  // 匹配英文字符、数字、中文、中文标点符号 。 ？ ！ ， 、 ； ： “ ” ‘ ' （ ） 《 》 〈 〉 【 】 『 』 「 」 ﹃ ﹄ 〔 〕 … — ～ ﹏ ￥ 常见英文标点符号

  let reg =
    /^[A-Za-z0-9|\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5|\s|·\.,\?!:/@...";'~<>\(\)\[\]\{\}\*&`#\$%\^_\+\-=\|\\]+$/
  return reg.test(str)
}

/**
 * 地址清洗
 * @param address
 * @returns {*}
 */
function cleanAddress(address, textFilter = []) {
  // 去换行等
  address = address.replace(/\r\n/g, ' ').replace(/\n/g, ' ').replace(/\t/g, ' ')

  // 自定义去除关键字，可自行添加
  const search = [
    '详细地址',
    '收货地址',
    '收件地址',
    '地址',
    '所在',
    '地区',
    '所在地区',
    '姓名',
    '收货人',
    '收件人',
    '联系人',
    '收',
    '邮编',
    '联系电话',
    '电话',
    '联系人手机号码',
    '手机号码',
    '手机号',
    '自治区直辖县级行政区划',
    '省直辖县级行政区划'
  ].concat(textFilter)
  search.forEach(str => {
    address = address.replace(new RegExp(str), ' ')
  })

  // const pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]\.<>/?~！@#￥……&*（）——|{}【】‘；：”“’。，、？]", 'g')
  // address = address.replace(pattern, ' ')

  // 多个空格replace为一个
  address = address.replace(/ {2,}/g, ' ')

  return address
}
/**
 * 格式化商品名称展示，从sku提取spu信息，numberGB前换行
 * @param formatSpuName
 * @returns {*}
 */
function formatSpuName(skuName, switchFlag = true) {
  if (switchFlag) {
    return skuName.split(/\s+\d+G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]*/)[0] + ' '
  }
  return ''
}

function getTempTerminal() {
  let tempTerminal = Number.parseInt(getQueryString('tempTerminal'))
  return isNaN(tempTerminal) ? -1 : tempTerminal
}

function replaceParamVal(paramName, replaceWith, isRefresh) {
  let oUrl = location.href.toString()
  if (paramName && replaceWith) {
    if (oUrl.indexOf(paramName + '=' + replaceWith) > 1) {
      return
    }
  }
  let nUrl = ''
  if (oUrl.indexOf('&' + paramName + '=') > 0) {
    let re = eval('/(&' + paramName + '=)([^&]*)/gi')
    nUrl = oUrl.replace(re, '&' + paramName + '=' + replaceWith)
  } else {
    if (oUrl.indexOf('?') > 0) {
      nUrl = oUrl + '&' + paramName + '=' + replaceWith
    } else {
      nUrl = oUrl + '?' + paramName + '=' + replaceWith
    }
  }
  // this.location = nUrl;
  if (isRefresh) {
    window.location.href = nUrl
  }
  history.replaceState(null, null, nUrl)
}

// 按照给定的字符数，截取汉字、字母、数字
function cutStr(str, L) {
  let result = ''
  // 字符串长度
  let strlen = str.length
  // 字节长度
  let chrlen = str.replace(/[^\x00-\xff]/g, '**').length

  if (chrlen <= L) return str

  for (let i = 0, j = 0; i < strlen; i++) {
    let chr = str.charAt(i)
    if (/[\x00-\xff]/.test(chr)) {
      j++ // ascii码为0-255，一个字符就是一个字节的长度
    } else {
      j += 2 // ascii码为0-255以外，一个字符就是两个字节的长度
    }
    if (j <= L) {
      // 当加上当前字符以后，如果总字节长度小于等于L，则将当前字符真实的+在result后
      result += chr
    } else {
      // 反之则说明result已经是不拆分字符的情况下最接近L的值了，直接返回
      return result
    }
  }
}

// 通知v消息内购当前页面是否是订单列表
function postInternally(name) {
  window.parent.postMessage(
    {
      type: 'ORDER-LIST-FROM-SHOP',
      value: name === 'orderList'
    },
    '*'
  )
}

/**
 * 打开地图导航
 * 使用场景：导航和路线规划
 * @param params
 */
function openNavi(params) {
  const { lng, lat, name = 'vivo官方商城', src = 'vivo官方商城', coordinate = 'gaode', callnative = 0 } = params
  const url = `https://uri.amap.com/marker?position=${lng},${lat}&name=${name}&src=${src}&coordinate=${coordinate}&callnative=${callnative}`
  app.openNewWebview({ url })
}
/**
 * 打开高德地图导航
 * 使用场景：高德导航及导航路径规划
 * @param params
 */
function openNaviByGaode(params) {
  const { lng, lat, key, destName, jscode,naviMode='car/bus/walk',callnative = 0 } = params
  const url = `https://m.amap.com/navi/?dest=${lng},${lat}&destName=${destName}&naviBy=${naviMode}&key=${key}&jscode=${jscode}&callnative=${callnative}`
  app.openNewWebview({ url })
}


function getMachineCode() {
  let model = ''
  if (clientEnv.isIOSVivoApp) {
    const key = 'deviceidentifier'
    const c = new RegExp('[?&]' + key + '=([^&]+)', 'g')
    const d = c.exec(clientEnv.ua)
    if (d) {
      model = d[1]
    }
  } else {
    try {
      const arr = clientEnv.ua.split(';')
      const str = arr.find(element => element.includes('build'))
      model = str.split('build')[0].trim()
    } catch (e) {
      model = ''
    }
  }
  return model
}

/**
 * 商品名称拆分成两行展示
 * @param name 商品名称
 * @param limit 颜色分隔符, 默认为' | '
 * @returns [Array] 商品名称拆分成两行展示
 */
function productName(name, limit) {
  const strArr = (name || '').split(/(\s+\d+G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]*.)/)
  const str1 = strArr[0].trim()
  let arr2 = strArr.slice(1)
  // 判断sku版本之后紧跟着一个（,而且规格_颜色字符串内存在中文括号时，增加新的名称规则逻辑。
  if (arr2[0] && arr2[0].indexOf('（') === arr2[0].length - 1) {
    if (arr2.join('').split(/(（.*）)/).length > 1) {
      arr2 = (name || '').split(/(\s+\d+G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]（.*）)/).slice(1)
    }
  }
  const str2 = arr2
    .filter(v => v.trim())
    .map(v => v.trim())
    .join(limit || ' | ')
  return [str1, str2]
}
async function initGdMap(){
  if (!window.AMap || !window.AMapUI) {
    let key = '2fe495214f0b8035db56beac12e46e12'
    await remoteLoad(`https://webapi.amap.com/maps?v=1.3&key=${key}`)
  }
}

export {
  setCookie,
  getCookie,
  removeCookie,
  getQueryString,
  serial,
  encodeJSON,
  getVisitType,
  parseQueryString,
  getParameter,
  getQueryParams,
  updateURLParameter,
  formatDate,
  formatTimeStr,
  formatMoney,
  formatNumber,
  formatMoneyInteger,
  formatMoneyDecimal,
  formatCount,
  formatPhone,
  formatTime,
  encryptMobile,
  formatName,
  debounce,
  jumpToShop,
  goBuy,
  jumpToActivity,
  convertHTML,
  formatRichTextLazyHTML,
  dealPayData,
  stopWinScroll,
  goBack,
  handleWXFontSize,
  isLogin,
  getBuild,
  shareRewardTip,
  isDarkColor,
  deepEqual,
  toggleClickable,
  isShowHeader,
  inputCheck,
  cleanAddress,
  getTempTerminal,
  formatSpuName,
  replaceParamVal,
  cutStr,
  postInternally,
  formatDistance,
  openNavi,
  openNaviByGaode,
  jumpToHome,
  jumpToNav,
  jumpToMy,
  jumpToKeFu,
  getMachineCode,
  productName,
  initGdMap,
  jumpToMiniUrl
}
